import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import FormControl from "@material-ui/core/FormControl";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core";
import ButtonWithSpinner from "../ButtonWithSpinner";
import useTags from "../../hooks/useTags";
import toastError from "../../errors/toastError";
import { BotaoCancelar, BotaoConfirmar } from "../BotoesModal";
import PontoCorEtiqueta from "../PontoCorEtiqueta";

const useStyles = makeStyles((theme) => ({
	maxWidth: {
		width: '100%',
	},
}));

const TicketAlterarEtiqueta = ({ modalOpen, onClose, user }) => {
	const [selectedTag, setSelectedTag] = useState("");
	const [tags, setTags] = useState([]);
	const [loading, setLoading] = useState(false);

	const classes = useStyles();
	const { findAll: findAllTags } = useTags("atribuir");

	useEffect(() => {
		if (!modalOpen) return;
		setLoading(false);
		setSelectedTag("");
		const loadTags = async () => {
			try {
				const listTags = await findAllTags();
				setTags(Array.isArray(listTags) ? listTags : []);
			} catch (err) {
				setTags([]);
				toastError(err);
			}
		};
		loadTags();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modalOpen]);

	const handleClose = async () => {
		setLoading(true);
		await onClose(selectedTag);
		setLoading(false);
	};

	const handleCancel = () => {
		setSelectedTag("");
		onClose();
	};

	return (
		<Dialog open={modalOpen} onClose={handleClose} fullWidth maxWidth="xs">
			<DialogTitle id="form-dialog-title">
				Alterar etiqueta do lead
			</DialogTitle>
			<DialogContent dividers>
				<FormControl variant="outlined" className={classes.maxWidth}>
					<InputLabel>Etiqueta</InputLabel>
					<Select
						value={selectedTag}
						onChange={(e) => setSelectedTag(e.target.value)}
						label="Etiqueta"
					>
						<MenuItem value={''}>&nbsp;</MenuItem>
						{tags.map((tag) => (
							<MenuItem key={tag.id} value={tag.id}>
								<PontoCorEtiqueta cor={tag.cor} />
								{tag.descricao}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</DialogContent>
			<DialogActions>
				<BotaoCancelar onClick={() => handleCancel()} disabled={loading}>
					Cancelar
				</BotaoCancelar>
				<BotaoConfirmar type="button" onClick={() => handleClose()} loading={loading}>
					Alterar
				</BotaoConfirmar>
			</DialogActions>
		</Dialog>
	);
};

export default TicketAlterarEtiqueta;
